export const appStore = 'https://apple.co/Sign_Up_DE_Social';
export const googlePlay = 'https://play.app.goo.gl/x1fX';
